module.exports = __webpack_public_path__ + "img/banner2.75ec56b2.jpg";